import useAxiosRequest from "../hooks/useAxiosRequest";

import "../styles/servers.css";
import config from "../config.json";

const Server = props => {
    const { server } = props;

    return (
        <div className="server">
            <img src={server.icon} alt={server.name}></img>
            <div className="inner-content">
                <span className="name">{server.name}</span>
                <a href={"/server/" + server.id}>Manage</a>
            </div>
        </div>
    );
}

const ServersListing = props => {
    const { isLoading, data: servers, error } = useAxiosRequest({
        url: `${config.backendUrl}/servers`,
        withCredentials: true,
        method: "get"
    });

    if (isLoading) return <p>Loading...</p>;

    if (error) return <p>{error.toString()}</p>;

    return <div id="servers-listing">{servers.map(server => <Server server={server}/>)}</div>;
}

export default ServersListing;
